// src/components/auth/VerifyEmailHandler.js
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Removed useNavigate as we'll use direct URL
import { getAuth, applyActionCode } from "firebase/auth";
import styles from "./VerifyEmailHandler.module.css"; // Import the CSS module

const VerifyEmailHandler = () => {
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  
  // Get the action code from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oobCode = queryParams.get("oobCode");
  
  useEffect(() => {
    const auth = getAuth();
    
    if (oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setSuccess(true);
          setVerifying(false);
        })
        .catch((error) => {
          console.error("Error verifying email:", error);
          setError("Failed to verify your email. The link may have expired or already been used.");
          setVerifying(false);
        });
    } else {
      setError("No verification code found in URL.");
      setVerifying(false);
    }
  }, [oobCode]);
  
  // Direct navigation to the main site
  const handleGoToLogin = () => {
    // Use window.location to redirect to the absolute URL
    window.location.href = "https://linkist.se/";
  };
  
  // Only provide dashboard option if we can determine user is logged in
  const handleGoToDashboard = () => {
    // Use window.location to redirect to the absolute URL for dashboard
    window.location.href = "https://linkist.se/dashboard";
  };
  
  if (verifying) {
    return (
      <div className={styles.verifyEmailContainer}>
        <div className={styles.loadingContainer}>
          <div className={styles.spinner}></div>
          <p>Verifying your email...</p>
        </div>
      </div>
    );
  }
  
  if (success) {
    return (
      <div className={styles.verifyEmailContainer}>
        <div className={styles.successContainer}>
          <h2>Email Verified!</h2>
          <p className={styles.successText}>
            Your email has been successfully verified. You can now sign in to use all features of Linkist.
          </p>
          <div className={styles.actionButtons}>
            <button onClick={handleGoToLogin} className={styles.button}>
              Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className={styles.verifyEmailContainer}>
      <div className={styles.errorContainer}>
        <h2>Email Verification Failed</h2>
        <p className={styles.errorText}>{error}</p>
        <div className={styles.actionButtons}>
          <button onClick={() => window.location.reload()} className={styles.button}>
            Try Again
          </button>
          <button onClick={handleGoToLogin} className={`${styles.button} ${styles.secondary}`}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailHandler;